import { useState, useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';

export const useAuthToken = () => {
    const [token, setToken] = useState("");
    const { getToken } = useAuth();

    useEffect(() => {
        const fetchToken = async () => {
            try {
                const sessionToken = await getToken({ template: "convex" });
                setToken(sessionToken || "");
            } catch (error) {
                setToken("");
            }
        };

        fetchToken();

        // Refresh token periodically (every 50 seconds, tokens typically expire at 60s)
        const interval = setInterval(fetchToken, 50 * 1000);
        return () => clearInterval(interval);
    }, [getToken]);

    return token;
};
